export const SSO_LOGIN = "sso_login";
export const PACKAGE_NAME = "io.parkplus.fusion";
